<script lang="ts">
    import { onMount } from "svelte";
    import { redirectTo } from "../scripts/router1";
    import { idPagePodcast } from "../scripts/router2";
    import { Podcast, storePodcasts, storePodcastCategoryPortrait, storePodcastCategoryLecture, storePodcastCategoryReportage, storePodcast, storePodcastCategory } from "../scripts/classes/podcast";
    import PodcastInsight from "../components/PodcastInsight.svelte";
    import { tick } from 'svelte';
    import { scrollTopMainRoute } from '../scripts/common';
    import { PODCAST_CATEGORY_1, PODCAST_CATEGORY_2, PODCAST_CATEGORY_3 } from '../scripts/constant';

    let category: string  = "0";

    onMount(async () => {
        storePodcastCategory.subscribe((storeCategory) => {
            category = storeCategory;
        });
    })

    tick().then(() => {
        scrollTopMainRoute();
    })

    function selectPodcast(idPodcast) {
        let param = "?id="+idPodcast;
        const podcastSelected: Podcast = $storePodcasts.filter((item) => {
            return (item.id == idPodcast);
        })[0];
        storePodcast.set(podcastSelected);
        redirectTo(idPagePodcast, param);
    }


</script>

<style lang="scss">

    .podcastsCategory {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        &__podcasts {
            width: 70%;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
        }
        &__podcast {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 100%;
            margin: 20px 0 20px 0;
        }
        &__empty {
            font-size: large;
        }
    }

    @include large {

        .podcastsCategory {
            height: 100%;
            &__podcasts {
                width: 80%;
                height: 100%;
                display: grid;
                grid-template-columns: 33% 34% 33%;
                margin: 0 0 50px 0;
            }
            &__podcast {
                cursor:pointer;
                margin: 100px 0 0 0;
            }
            &__left {
                grid-column: 1/3;
            }
            &__right {
                grid-column: 2/4;
            }
            &__empty {
                grid-column: 2/3;
            }
        }

    }
</style>
<div class="podcastsCategory">
    <div class="podcastsCategory__podcasts">
        {#if (category == "1")}
            {#if ($storePodcastCategoryPortrait.length > 0)}
                {#each $storePodcastCategoryPortrait as item, i}
                <div id="idPodcastsCategoryPodcast{i}"></div>
                <div class="podcastsCategory__podcast" class:podcastsCategory__left={i%2 == 0} class:podcastsCategory__right={i%2 != 0} on:click={() => selectPodcast(item.id)} on:keydown={() => selectPodcast(item.id)}>
                    <PodcastInsight props={{podcast: item}} />
                </div>
                {/each}
            {:else}
                <div class="podcastsCategory__empty">Pas encore de podcasts "{PODCAST_CATEGORY_1.label}"<br>Merci de votre patience</div>
            {/if}
        {/if}
        {#if (category == "2")}
            {#if ($storePodcastCategoryLecture.length > 0)}
                {#each $storePodcastCategoryLecture as item, i}
                <div class="podcastsCategory__podcast" class:podcastsCategory__left={i%2 == 0} class:podcastsCategory__right={i%2 != 0} on:click={() => selectPodcast(item.id)} on:keydown={() => selectPodcast(item.id)}>
                    <PodcastInsight props={{podcast: item}} />
                </div>
                {/each}
            {:else}
                <div class="podcastsCategory__empty">Pas encore de podcasts "{PODCAST_CATEGORY_2.label}"<br>Merci de votre patience</div>
            {/if}
        {/if}
        {#if (category == "3")}
            {#if ($storePodcastCategoryReportage.length > 0)}
                {#each $storePodcastCategoryReportage as item, i}
                <div class="podcastsCategory__podcast" class:podcastsCategory__left={i%2 == 0} class:podcastsCategory__right={i%2 != 0} on:click={() => selectPodcast(item.id)} on:keydown={() => selectPodcast(item.id)}>
                    <PodcastInsight props={{podcast: item}} />
                </div>
                {/each}
            {:else}
                <div class="podcastsCategory__empty">Pas encore de podcasts "{PODCAST_CATEGORY_3.label}"<br>Merci de votre patience</div>
            {/if}
        {/if}
    </div>
    
</div>
